<template>
  <div>
    <Pie
    :chartData="ChartData"
    :chart-options="chartOptions"
    :plugins="plugins" />
  </div>
</template>

<script>
import {
  Chart,
  registerables,
} from 'chart.js';
import { Pie } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { CHART_COLORS } from '@/constants/color';

Chart.register(...registerables);

export default {
  name: 'PieChart',
  components: {
    Pie,
  },
  props: {
    labelsData: { // 表に付属する色と対応しているデータの情報を表すラベル
      type: Array,
      default: null,
    },
    datasetsData: { // グラフ描画用データ
      type: Object,
      default: null,
    },
    labelSuffix: { // ラベルに追加する接尾辞（例: '歳'）
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ChartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        plugins: {
          legend: {
            display: false,
            // position: 'bottom',
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const label = context.label;
                const value = context.parsed;
                const labelWithSuffix = this.labelSuffix ? `${label}${this.labelSuffix}` : label;
                return `${labelWithSuffix}: ${value}`;
              },
            },
          },
          datalabels: {
            ...CHART_COLORS.pieLabels,
            formatter: (value, context) => {
              const dataset = context.chart.data.datasets[0];
              const total = dataset.data.reduce((acc, val) => acc + val, 0);

              // データがない場合は非表示
              if (!total || total === 0) {
                return null;
              }

              const percentage = Math.round((value / total) * 100);
              const label = context.chart.data.labels[context.dataIndex];
              const labelWithSuffix = this.labelSuffix ? `${label}${this.labelSuffix}` : label;

              // 5%未満: 非表示
              if (percentage < 5) {
                return null;
              }
              // 5-10%: パーセンテージのみ
              if (percentage < 10) {
                return `${percentage}%`;
              }
              // 10%以上: ラベル名 + パーセンテージ
              return `${labelWithSuffix}\n${percentage}%`;
            },
            display: 'auto', // 重なったらベルを非表示にする（重なりの判定はデフォルトで行われる）
            anchor: 'center',
            align: 'center',
          },
        },
        // maintainAspectRatio: false, // グラフ幅が狭くなっても高さを維持する
      },
      plugins: [ChartDataLabels],
    };
  },
  created() {
  },
  mounted() {
    this.drawGraph();
  },
  watch: {
    labelsData() { // 期日や絞り込み条件の変動があったら再描画
      this.updateGraph();
    },
  },
  methods: {
    updateGraph() {
      this.ChartData.labels = [];
      this.ChartData.datasets = [];
      this.drawGraph();
    },
    drawGraph() {
      this.labelsData.forEach((elem) => {
        this.ChartData.labels.push(elem);
      });
      this.ChartData.datasets.push(this.datasetsData);
    },
  },
};
</script>
